import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';
import type { ILogAnalytics } from 'shared/middlewares/analytics/logger';

import { changeAnalyticsUserConsentEpic } from './changeAnalyticsUserConsent';
import { startAnalyticsEpic } from './startAnalyticsEpic';
export const analyticsEpics = (logAnalytics: ILogAnalytics) =>
  withAppCrashIfException(
    'analytics',
    combineEpics(startAnalyticsEpic(logAnalytics), changeAnalyticsUserConsentEpic(logAnalytics)),
  );
